import React from "react";

import { NavLink } from "react-router-dom";

import { FAST_2_0 } from "@/src/constants/fast";

import DataTableColumnHeader from "../../dataTable/DataTableColumnHeader";
import { fastChannelDistributePath } from "../../routes/routes";

import type { TFunction } from "i18next";

import type { FastChannelListItem } from "../../../api/FastAPI.types";
import type { DataTableColumnDef } from "../../dataTable/dataTable.types";

interface ChannelColumnsOptions {
  t: TFunction;
}

/** Page de la chaîne ; `undefined` pour une version sans page (hors FAST 2.0). */
export function getChannelHref(
  channel: FastChannelListItem,
): string | undefined {
  return channel.version === FAST_2_0
    ? fastChannelDistributePath(channel.uuid)
    : undefined;
}

export function channelColumns({
  t,
}: ChannelColumnsOptions): DataTableColumnDef<FastChannelListItem>[] {
  return [
    {
      accessorKey: "version_label",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("version")} />
      ),
      enableSorting: false,
      meta: {
        label: t("version"),
        width: "14%",
        minWidth: 95,
        align: "center",
      },
    },
    {
      accessorKey: "name",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("channelName")} />
      ),
      meta: { label: t("channelName") },
      cell: ({ row }) => {
        const { name, logo_url: logoUrl } = row.original;
        const href = getChannelHref(row.original);
        const label = (
          <span className="flex items-center gap-2 overflow-hidden">
            {logoUrl ? (
              <img alt={name} className="size-6.25" src={logoUrl} />
            ) : null}
            <span className="truncate" title={name}>
              {name}
            </span>
          </span>
        );

        return href ? (
          <NavLink
            className="focus-visible:ring-ring/50 flex rounded-sm outline-none focus-visible:ring-[3px]"
            to={href}
          >
            {label}
          </NavLink>
        ) : (
          label
        );
      },
    },
    {
      accessorKey: "schedules_count",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("scheduling")} />
      ),
      meta: {
        label: t("scheduling"),
        width: "25%",
        minWidth: 152,
        align: "center",
      },
    },
    {
      accessorKey: "broadcasts_count",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("destinations")} />
      ),
      meta: {
        label: t("destinations"),
        width: "25%",
        minWidth: 152,
        align: "center",
      },
    },
  ];
}
